import React, { Component } from 'react';

class Caro extends Component {
  render() {
    let carouselFixID = `id${this.props.caroId}-fixid`;
    let carouselFixIDhash = `#id${this.props.caroId}-fixid`;

    return (
      <div className="card-img-top">
        <div id={carouselFixID} className="carousel slide carousel-fade" data-ride="carousel" data-interval="5000">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img className="d-block w-100" src={this.props.activeCaro} alt={carouselFixID} />
            </div>

            {this.props.imgs.map((p) => (
              <div key={p.img} className="carousel-item">
                <img className="d-block w-100" src={p.img} alt={carouselFixID} />
              </div>
            ))}
          </div>
          <a className="carousel-control-prev d-md-none" href={carouselFixIDhash} role="button" data-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="sr-only">Previous</span>
          </a>
          <a className="carousel-control-next d-lg-none" href={carouselFixIDhash} role="button" data-slide="next">
            <span className="carousel-control-next-icon text-secondary" aria-hidden="true"></span>
            <span className="sr-only">Next</span>
          </a>
        </div>
      </div>
    );
  }
}

export default Caro;
